export default __webpack_public_path__ + "static/AKB-88b619ab84a7a4dac934aaedb5d8f45a.jpeg";